//编辑文章
<template>
  <div class="edit">
    <tiny-editor></tiny-editor>
    
  </div>
</template>

<script>
import TinyEditor from '../components/tiny-editor'
export default {
    components:{
        TinyEditor
    },
    data() {
        return {
        }
    },
    methods: {
    },
    created(){
    },
}
</script>

<style lang="scss" scoped>
    // .edit{
    //     // width: 100%;
    //     background: #fff;
    //     // padding:20px 20px 100px 20px;
    // }

  
</style>